import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { VaultAccountDetailsType } from '@/types/myVaultTypes';

export const getVaultAccountApi = (id: string): Promise<ApiResponseType<VaultAccountDetailsType>> => {
  return authApiService.GET(`/my-vault/accounts/${id}/`);
};
